import React, { FC, useEffect } from 'react';
import { useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { activateUser } from '../../api/apis';
import { User } from '../../lib/interfaces/User';
import Loader from '../Simple/Loader/Loader';
import { setActivationResultModalOpen } from '../../redux/reducers/ui/modalsReducer';
import { useAppDispatch } from '../../hooks/redux';
import useUserMeQuery from '../../reactQuery/hooks/useUserMeQuery';
import paths from '@/lib/consts/paths';

const UserActivation: FC<any> = () => {
	const { activationToken = '' } = useParams();
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const { data, error, isSuccess, isError } = useQuery<User, Error>(
		['activate-user'],
		() => activateUser(activationToken),
		{
			enabled: !!activationToken,
		},
	);

	const refetchedUser = useUserMeQuery({
		enabled: !!isSuccess,
	});

	useEffect(() => {
		if (isSuccess || isError) {
			dispatch(setActivationResultModalOpen(true));
		}
		if (isSuccess && refetchedUser.isSuccess) {
			const refecth = refetchedUser.refetch();
			refecth.then(() => {
				if (refetchedUser.data?.subscriptionPlanId) {
					navigate(paths.courses);
				} else {
					navigate(paths.plans);
				}
			});
		}
		if (isError) {
			navigate('/');
		}
	}, [activationToken, isSuccess, isError, refetchedUser.isSuccess]);

	return <div>{!(data || error) && <Loader />}</div>;
};

export default UserActivation;
